import { useState } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/lib/auth'
import { Button } from './Button'
import { Sidebar } from './Sidebar'
import { SkeletonTeks } from './Skeleton'

/**
 * Kerangka halaman terautentikasi: sidebar + header + area konten.
 *
 * Halaman wajib-ganti-kata-sandi TIDAK memakai layout ini (lihat App.tsx)
 * supaya tetap terjangkau saat backend memblokir seluruh endpoint lain.
 */
export function Layout() {
  const { pengguna, siap, keluar, unit } = useAuth()
  const [sidebarTerbuka, setSidebarTerbuka] = useState(false)
  const lokasi = useLocation()

  if (!siap) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-netral-100 p-6">
        <div className="w-full max-w-sm rounded-xl border border-netral-200 bg-white p-6">
          <SkeletonTeks baris={4} />
          <p className="mt-4 text-center text-sm text-netral-500">Memuat sesi…</p>
        </div>
      </div>
    )
  }

  if (!pengguna) {
    return <Navigate to="/login" replace state={{ dari: lokasi.pathname }} />
  }

  if (pengguna.mustChangePassword) {
    return <Navigate to="/ganti-kata-sandi" replace />
  }

  return (
    <div className="flex min-h-screen bg-netral-100">
      <Sidebar terbuka={sidebarTerbuka} onTutup={() => setSidebarTerbuka(false)} />

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="sticky top-0 z-20 flex items-center gap-3 border-b border-netral-200 bg-white px-4 py-2.5">
          <button
            type="button"
            className="rounded-lg border border-netral-300 px-2.5 py-1.5 text-sm lg:hidden"
            onClick={() => setSidebarTerbuka(true)}
            aria-label="Buka menu"
          >
            ☰
          </button>

          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium text-netral-800">
              Selamat datang, {pengguna.fullName}
            </p>
            <p className="truncate text-xs text-netral-500">
              {unit.length > 0
                ? `${unit.length} unit dapat diakses · ${pengguna.roles.map((r) => r.name).join(', ')}`
                : 'Belum ada penugasan unit'}
            </p>
          </div>

          <span className="hidden rounded-full border border-netral-200 px-2.5 py-1 text-xs text-netral-600 sm:inline">
            IDR · Asia/Jakarta
          </span>
          <Button varian="garis" ukuran="kecil" onClick={() => void keluar()}>
            Keluar
          </Button>
        </header>

        <main className="min-w-0 flex-1 px-4 py-5 sm:px-6">
          <Outlet />
        </main>

        <footer className="border-t border-netral-200 px-4 py-3 text-center text-xs text-netral-400">
          Sistem Informasi Keuangan Terpadu Yayasan
        </footer>
      </div>
    </div>
  )
}
